export class User {
    id: string;
    token: string;
    username: string;
    name: string;
    avatarUrl: string;
    nrLogin: number;
    viewPermissions: any;
    groups: any[];
    domain: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/user.model.ts